import { render, staticRenderFns } from "./VueLazyCascaderExample.vue?vue&type=template&id=33e5975c&scoped=true"
import script from "./VueLazyCascaderExample.vue?vue&type=script&lang=js"
export * from "./VueLazyCascaderExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.6.14_webpack@5.104.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e5975c",
  null
  
)

export default component.exports